import React from 'react';
import { Columns, Column, Button } from '@codeparva/ui-components-library';
import {
  CustomTextField,
  CustomUneditableField,
} from '../FormFields/GeneralFormFields';
import { useFormikContext, Form, FieldArray } from 'formik';
import { CustomPhoneNumberField } from '../FormFields/UpdateContactDetailsFormFields';
import { weakKey } from '../../../../utilities/weakKey';

export const UpdateContactDetailsForm = () => {
  const {
    isSubmitting,
    handleSubmit,
    dirty,
    isValid,
    values,
  } = useFormikContext<any>();

  return (
    <>
      <Form>
        <Columns className="is-multiline">
          <>
            <Column size={'half'}>
              <CustomTextField
                label="First Name"
                name="first_name"
                fieldname="first_name"
                type="text"
              />
            </Column>
          </>
          <Column size={'half'}>
            <CustomTextField
              label="Last Name"
              name="last_name"
              fieldname="last_name"
              type="text"
            />
          </Column>
          <Column paddingless className="uneditableSection">
            <Column size={'half'}>
              <CustomUneditableField
                label="Email Address"
                name="email_address"
                fieldname="email_address"
                type="email"
                readOnly
              />
            </Column>
            <Column size={'half'}>
              <CustomUneditableField
                label="Alternate Email Address"
                name="alternate_email"
                fieldname="alternate_email"
                type="email"
                readOnly
              />
            </Column>
            {values.phone && (
              <FieldArray
                name="phone"
                render={() => (
                  <>
                    {values.phone.map((indivPhoneNumber: any, i: number) => {
                      return (
                        <Column size="half" key={weakKey({ indivPhoneNumber })}>
                          <CustomPhoneNumberField
                            name={`phone[${i}].phone_id`}
                            fieldname={`phone[${i}].phone_id`}
                            label={`${indivPhoneNumber.type.replace('_', ' ')}`}
                            type="text"
                            country_code={indivPhoneNumber.phone.country_code}
                            area_code={indivPhoneNumber.phone.area_code}
                            number={indivPhoneNumber.phone.number}
                            readOnly
                          />
                        </Column>
                      );
                    })}
                  </>
                )}
              />
            )}
            <Column className="is-full">
              <CustomUneditableField
                label="Address Line 1"
                name="address.line1"
                fieldname="address.line1"
                type="text"
                readOnly
              />
            </Column>
            {/* <Column className="is-full">
              <CustomUneditableField
                label="Address Line 2"
                name="address.line2"
                fieldname="address.line2"
                type="text"
                readOnly
              />
            </Column> */}
            <Column size={'half'}>
              <CustomUneditableField
                label="State"
                name="address.state"
                fieldname="address.state"
                type="text"
                readOnly
              />
            </Column>
            <Column size={'half'}>
              <CustomUneditableField
                label="City"
                name="address.city"
                fieldname="address.city"
                type="text"
                readOnly
              />
            </Column>
            <Column size={'half'}>
              <CustomUneditableField
                label="Country"
                name="address.country"
                fieldname="address.country"
                type="text"
                readOnly
              />
            </Column>
            <div className="overlaySection"></div>
          </Column>
        </Columns>
        <Column className="buttonContainer">
          <Button
            type="button"
            onClick={(e: any) => handleSubmit(e)}
            disabled={isSubmitting || !dirty || !isValid}
            className="updateContactDetailsBtn"
          >
            Update Details
          </Button>
        </Column>
      </Form>
    </>
  );
};
